import { call } from "redux-saga/effects";

import { backOfficeApiService } from "../../../../actionService/apiService";
import { ApiCallResult } from "../../../../types";

import endPoints from "./productUsageEvents.endpoints";
import { ProductUsageEventRequestDto } from "./productUsageEvents.requestsDto";

const backOfficeProductUsageEventsApi = {
  record: function* (dto: ProductUsageEventRequestDto) {
    return (yield call([backOfficeApiService, backOfficeApiService.Post], endPoints.controller, dto)) as ApiCallResult;
  },
};

export default backOfficeProductUsageEventsApi;
